// extracted by mini-css-extract-plugin
export var measureBox = "_40-0";